import axios from "axios";

const api_base_url =
  process.env.REACT_APP_API_BASEURL + "/OfficeApplianceBrand";

export const addOfficeApplianceBrand = async (newBrand: any) => {
  const { data } = await axios.post(`${api_base_url}`, newBrand);

  return data;
};
